// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bab3b4a7","316":"ace6a9f3","396":"c390b893","455":"79837308","977":"8a6eabc9"}[chunkId] + ".chunk.js";
};